import {useTranslations} from 'next-intl';
import {Row, Col} from '@/grid';
import Container from '@/container';
import IntroBox from '@/ui/introbox';
import {H3, P} from '@/typography';
import {withFlexHolder} from '@/hocs/withFlex';
import {withMarginBottomSm, withMarginBottomMd} from '@/hocs/withSpacing';
import {SectionSpacedTopLgToDouble} from '@/section';
import PictureWrapper from '@/ui/images-wrapper';
import {BgNeutral200Div, DivMarginedLg, Grid, H2MarginedMd} from '@/content/workable-ai/shared';
import styles from './agent-control-compliance-section.module.scss';

const FlexHolderRow = withFlexHolder(Row);
const H3MarginedSm = withMarginBottomSm(H3 as never);
const PMarginMd = withMarginBottomMd(P as never);

const imgPath = '/static/images/workable-ai/';

const AgentControlComplianceSection = () => {
  const controlT = useTranslations('workableAi.agentControl');
  const complianceT = useTranslations('workableAi.agentCompliance');

  return (
    <BgNeutral200Div>
      <SectionSpacedTopLgToDouble>
        <Container>
          <Grid fluid>
            <FlexHolderRow>
              <Col xs={12} lg={5}>
                <IntroBox>
                  <H2MarginedMd>{controlT('title')}</H2MarginedMd>
                  <H3MarginedSm className="heading-4">{controlT('granularControlsTitle')}</H3MarginedSm>
                  <PMarginMd>{controlT('granularControlsBody')}</PMarginMd>
                  <H3MarginedSm className="heading-4">{controlT('humanReviewTitle')}</H3MarginedSm>
                  <PMarginMd>{controlT('humanReviewBody')}</PMarginMd>
                  <H3MarginedSm className="heading-4">{controlT('killSwitchTitle')}</H3MarginedSm>
                  <PMarginMd>{controlT('killSwitchBody')}</PMarginMd>
                </IntroBox>
              </Col>
              <Col xs={12} lg={6} lgOffset={1} first="xs" last="lg">
                <DivMarginedLg>
                  <PictureWrapper
                    imgPath={imgPath}
                    imageUrl="agent-stay-in-control"
                    imageTypeFallback="jpg"
                    altImage={controlT('imageAlt')}
                    className={styles['image-rounded']}
                  />
                </DivMarginedLg>
              </Col>
            </FlexHolderRow>
          </Grid>
        </Container>
      </SectionSpacedTopLgToDouble>

      <SectionSpacedTopLgToDouble>
        <Container>
          <Grid fluid>
            <FlexHolderRow>
              <Col xs={12} lg={6}>
                <DivMarginedLg>
                  <PictureWrapper
                    imgPath={imgPath}
                    imageUrl="agent-compliance"
                    imageTypeFallback="jpg"
                    altImage={complianceT('imageAlt')}
                    className={styles['image-rounded']}
                  />
                </DivMarginedLg>
              </Col>
              <Col xs={12} lg={5} lgOffset={1}>
                <IntroBox>
                  <H2MarginedMd>{complianceT('title')}</H2MarginedMd>
                  <H3MarginedSm className="heading-4">{complianceT('regulatoryTitle')}</H3MarginedSm>
                  <PMarginMd>{complianceT('regulatoryBody')}</PMarginMd>
                  <H3MarginedSm className="heading-4">{complianceT('biasTitle')}</H3MarginedSm>
                  <PMarginMd>{complianceT('biasBody')}</PMarginMd>
                  <H3MarginedSm className="heading-4">{complianceT('transparentTitle')}</H3MarginedSm>
                  <PMarginMd>{complianceT('transparentBody')}</PMarginMd>
                </IntroBox>
              </Col>
            </FlexHolderRow>
          </Grid>
        </Container>
      </SectionSpacedTopLgToDouble>
    </BgNeutral200Div>
  );
};

export default AgentControlComplianceSection;
